import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { IMAGE_FILE_TYPES } from "@/libs/builder/consts";

export const comingSoonDefaultValues = {
  title: "Coming Soon",
  description: "We're working on something exciting! Check back soon.",
  subtitle: "Nordic spirit white snus",
  warningBannerText: "For adult use only. These products are not risk-free and are addictive",
  desktopBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fb5f09bb7655b461f952797e2ffd0658a",
    alt: "Coming Soon",
    title: "Coming Soon",
  },
  tabletBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fb5f09bb7655b461f952797e2ffd0658a",
    alt: "Coming Soon",
    title: "Coming Soon",
  },
  mobileBackgroundImage: {
    src: "https://cdn.builder.io/api/v1/image/assets%2F90293f7dc9704cb5935f357315020051%2Fb5f09bb7655b461f952797e2ffd0658a",
    alt: "Coming Soon",
    title: "Coming Soon",
  },
};

export const comingSoonInputs = [
  {
    name: "logo",
    type: "object",
    defaultValue: {
      link: "/",
      srcDark:
        "https://cdn.builder.io/api/v1/image/assets%2Feae5cb15c27f457fa99960c54a9aaf92%2F661289b3429a4853874c4f1aede8e609",
      srcLight:
        "https://cdn.builder.io/api/v1/image/assets%2Feae5cb15c27f457fa99960c54a9aaf92%2F661289b3429a4853874c4f1aede8e609",
      title: "Coming soon logo",
      alt: "Logo",
    },
    subFields: [
      { name: "link", type: "url", required: true },
      { name: "srcDark", type: "file", allowedFileTypes: IMAGE_FILE_TYPES },
      { name: "srcLight", type: "file", allowedFileTypes: IMAGE_FILE_TYPES },
      { name: "title", type: "string", required: true },
      { name: "alt", type: "string", required: true },
      { name: "width", type: "number" },
    ],
  },
  {
    name: "title",
    type: "string",
    defaultValue: comingSoonDefaultValues.title,
  },
  {
    name: "description",
    type: "string",
    defaultValue: comingSoonDefaultValues.description,
  },
  {
    name: "subtitle",
    type: "string",
    defaultValue: comingSoonDefaultValues.subtitle,
  },
  {
    name: "warningBannerText",
    type: "string",
    defaultValue: comingSoonDefaultValues.warningBannerText,
  },
  {
    name: "desktopBackgroundImage",
    type: "object",
    required: true,
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: comingSoonDefaultValues.desktopBackgroundImage,
  },
  {
    name: "tabletBackgroundImage",
    type: "object",
    required: true,
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: comingSoonDefaultValues.tabletBackgroundImage,
  },
  {
    name: "mobileBackgroundImage",
    type: "object",
    required: true,
    subFields: [
      {
        name: "src",
        type: "file",
        allowedFileTypes: IMAGE_FILE_TYPES,
        required: true,
      },
      {
        name: "alt",
        type: "string",
        required: true,
      },
      {
        name: "title",
        type: "string",
        required: true,
      },
    ],
    defaultValue: comingSoonDefaultValues.mobileBackgroundImage,
  },
] as const satisfies Inputs;

export type ComingSoonProps = BuilderComponentProps<typeof comingSoonInputs>;

export const ComingSoonComponent: RegisteredComponent = {
  name: "ComingSoon",
  component: dynamic(() => import("./ComingSoon").then((mod) => mod.ComingSoon)),
  inputs: comingSoonInputs,
};
